import { render, staticRenderFns } from "./changeTag.vue?vue&type=template&id=6fbefc5f&scoped=true&"
import script from "./changeTag.vue?vue&type=script&lang=js&"
export * from "./changeTag.vue?vue&type=script&lang=js&"
import style0 from "./changeTag.vue?vue&type=style&index=0&id=6fbefc5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbefc5f",
  null
  
)

export default component.exports